export default __webpack_public_path__ + "static/media/περιμετρικη υπερχειλιση3.c5c7269f.webp";